<div class="row driver-filter align-content-end">
  <div class="input-group justify-content-end">
    <span class="w-100 input-group-text bg-transparent border-1 border-left z-1 filter-container">
      <a class="nav-link dropdown-toggle py-1" href="#" role="button" data-bs-toggle="dropdown"
        aria-expanded="false" data-bs-auto-close="outside" #dropdownTrigger>
        <i class="ph ph-funnel-simple"></i>
        <span class="text-dark px-2">{{ (isLoading ? 'shared.driverFilter.loading' : 'shared.driverFilter.filterBy') | transloco }}</span>
      </a>
      <span *ngIf="selectedDriversCount > 0" class="bg-danger text-white py-1 px-2 rounded-2 text-xs">
        {{ selectedDriversCount}}
      </span>

      <ul class="dropdown-menu custom-dropdown border-0" #dropdown>
        <div class="d-flex justify-content-center" *ngIf="isLoading">
          <span *ngIf="isLoading" class="spinner-border"></span>
        </div>
        <div class="sticky-top bg-white p-2" *ngIf="!isLoading">
          <div class="input-group align-items-center">
            <div
              class="col-1 ps-2 d-flex justify-content-center align-items-center rounded-start-3 border-1 search-icon">
              <i class="ph ph-magnifying-glass"></i>
            </div>

            <div class="col-11">
              <input type="text" class="ps-3 rounded-end-3 border-1 search-input" [attr.aria-label]="'accountFilter.search' | transloco"
                [placeholder]="(isLoading ? 'shared.driverFilter.loading' : 'shared.driverFilter.searchPlaceholder') | transloco" [(ngModel)]="driverName"
                (input)="searchDrivers($event)" (click)="openDropdown($event)" />
            </div>
          </div>
        </div>
        
        <div class="dropdown-scroll" *ngIf="!isLoading">
          <!-- 
            NOTE: minBufferPx should have the same size as the viewport height 
            maxBufferPx should have 2.5x the height of viewport height
            -->
          <cdk-virtual-scroll-viewport itemSize="40" minBufferPx="400" maxBufferPx="1000" class="viewport">
            <li *cdkVirtualFor="let item of filteredDriversTree; let i = index;" class="dropdown-item">
              <label [ngStyle]="{ 'padding-left.px': item.hierarchyLevel * 32 }"
                [ngClass]="{'parent-item': item.isParent}">
                <input type="checkbox" [checked]="item.checked" (click)="onCheckboxChange(item)" />
                <span [appDriverVehicleAssetIcon]="item" [entityType]="'driver'"></span>
                <span>{{ item.name }}</span>
              </label>
            </li>
          </cdk-virtual-scroll-viewport>
        </div>
      </ul>
    </span>
  </div>
</div>